import { React, useState } from "react";
import { sendPostRequest } from "../../Client/index.js";

const Add = ({ onAdded }) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [adding, setAdding] = useState({});

  const handleSubmit = async () => {
    if (!search.trim()) return;

    setLoading(true);
    setError("");
    setHasSearched(true);
    try {
      const res = await sendPostRequest(`friends/lookup`, { search });
      console.log("Search results:", res);
      setResults(res?.users || []);
    } catch (e) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddFriend = async (user) => {
    const id = user.ballerzUserID ?? user.id ?? user.username;
    setAdding((m) => ({ ...m, [id]: true }));
    setError("");

    try {
      console.log("responder", id);

      const res = await sendPostRequest(`friends/add`, { responder: id });

      console.log("Add friend response:", res);

      if (res?.status === "success") {
        setResults((prev) =>
          prev.map((u) =>
            (u.ballerzUserID ?? u.id ?? u.username) === id
              ? { ...u, requested: true }
              : u
          )
        );

        onAdded?.({
          ballerzUserID: user.ballerzUserID,
          username: user.username,
        });
      } else {
        throw new Error(res?.message || "Unable to send request");
      }
    } catch (e) {
      setError(e.message || "Unable to send request");
    } finally {
      setAdding((m) => ({ ...m, [id]: false }));
    }
  };

  return (
    <div className="flex flex-col justify-start">
      <div className="flex justify-center mb-6">
        <div className="flex flex-col sm:flex-row w-full max-w-md gap-2 sm:gap-4">
          <input
            type="search"
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            value={search}
            placeholder="Enter a username or email"
            className="bg-[#1f2644] rounded-md px-4 py-3 text-white Kallisto_Bold flex-1 focus:outline-none focus:ring-2"
          />
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-green-700 hover:bg-green-600 disabled:opacity-60 py-4 px-8 rounded flex items-center justify-center gap-3"
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4A4 4 0 008 12H4z"
                  />
                </svg>
                <span className="text-white Kallisto_Bold">Searching…</span>
              </>
            ) : (
              <span className="text-white Kallisto_Bold font-bold whitespace-nowrap">
                Search
              </span>
            )}
          </button>
        </div>
      </div>

      <div className="mx-auto w-full max-w-md">
        {error && (
          <div className="bg-red-900/40 border border-red-600 text-red-100 rounded-md px-4 py-3 mb-4 Kallisto_Bold">
            {error}
          </div>
        )}

        {loading && (
          <div className="space-y-3 mb-4">
            <div className="h-5 rounded bg-[#1f2644] animate-pulse" />
            <div className="h-5 rounded bg-[#1f2644] animate-pulse" />
            <div className="h-5 rounded bg-[#1f2644] animate-pulse" />
          </div>
        )}

        {!loading && results && results.length > 0 && (
          <ul className="space-y-2">
            {results.map((user) => {
              const id = user.ballerzUserID ?? user.id ?? user.username;
              const isAdding = !!adding[id];
              const requested = !!user.requested;

              return (
                <li
                  key={id}
                  className="bg-[#2a3157] rounded-md px-4 py-3 flex items-center justify-between"
                >
                  <div>
                    <div className="text-white Kallisto_Bold">
                      {user.username}
                    </div>
                    {user.name && (
                      <div className="text-sm text-white/70">{user.name}</div>
                    )}
                  </div>

                  {(() => {
                    const isFriends =
                      user.status_requester_to_user === 1 ||
                      user.status_user_to_requester === 1;

                    const isPendingServer =
                      user.status_requester_to_user === 0 ||
                      user.status_user_to_requester === 0;

                    const isPending = isPendingServer || requested;

                    if (isFriends) {
                      return <div className="Kallisto_Bold">FRIENDS</div>;
                    }

                    if (isAdding) {
                      return (
                        <button
                          disabled
                          className="text-sm text-white rounded px-3 py-2 Kallisto_Bold bg-[#3b41f3]/60 cursor-default"
                        >
                          Sending…
                        </button>
                      );
                    }

                    if (isPending) {
                      return (
                        <button
                          disabled
                          className="text-sm text-white rounded px-3 py-2 Kallisto_Bold bg-[#3b41f3]/60 cursor-default"
                        >
                          Request Sent
                        </button>
                      );
                    }

                    return (
                      <button
                        onClick={() => handleAddFriend(user)}
                        disabled={isAdding || requested}
                        className="text-sm text-white rounded px-3 py-2 Kallisto_Bold bg-[#4F55F6] hover:bg-[#3b41f3] disabled:opacity-60"
                      >
                        Add as a friend
                      </button>
                    );
                  })()}
                </li>
              );
            })}
          </ul>
        )}

        {!loading && hasSearched && results.length === 0 && !error && (
          <div className="text-white/70 text-sm Kallisto_Bold ml-2">
            No users found. Try again with a different username or email
            address.
          </div>
        )}
      </div>
    </div>
  );
};

export default Add;
